import React, { useState } from "react";
import Vimeo from "@u-wave/react-vimeo";
import classes from "./VimeoComponent.module.css";

const VimeoComponent = props => {
  return (
    <div className={classes.video_container}>
      <Vimeo
        video={props.videoUrl}
        // paused={false}
        // paused={!props.isPlaying}
        autopause={true}
        onPlay={() => props.setIsPlaying(true)}
        onPause={() => props.setIsPlaying(false)}
      />
    </div>
  );
};

export default VimeoComponent;
